module.exports = __webpack_public_path__ + "img/protocol3.e0c0c373.png";